// GDPRLocal shared navigation and footer data. Links are absolute to the live site.
const SITE = "https://gdprlocal.com";
const PORTAL_LOGIN = "https://portal.gdprlocal.com/Account/Login";
const PORTAL_REGISTER = "https://portal.gdprlocal.com/Account/Register";

const abs = (p) => `${SITE}${p}`;

export const BRAND = {
  SITE,
  PORTAL_LOGIN,
  PORTAL_REGISTER,
  LOGO: "https://gdprlocal.com/wp-content/uploads/2024/10/logo_header.png",
};

export const NAV = [
  {
    label: "Services",
    items: [
      { label: "EU Representative", href: abs("/gdpr-article-27-eu-representative/") },
      { label: "UK Representative", href: abs("/gdpr-article-27-uk-representative/") },
      { label: "Swiss Representative", href: abs("/fadp-article-14-swiss-representative/") },
      { label: "EU AI Act Article 22 Representative", href: abs("/ai-representative/") },
      { label: "DPO Service", href: abs("/gdpr-data-protection-officer/") },
      { label: "Singapore DPO", href: abs("/singapore-dpo/") },
      { label: "Consultancy", href: abs("/gdpr-consultant/") },
      { label: "AI Governance", href: abs("/ai-governance/") },
      { label: "AI and Data Protection Training", href: abs("/ai-and-data-protection-compliance-training/") },
      { label: "Project Delivery", href: abs("/compliance-projects/") },
    ],
  },
  {
    label: "Solutions",
    items: [
      { label: "Start-ups and fast movers", href: abs("/solutions/start-ups-and-fast-movers/") },
      { label: "SME and hyper growth", href: abs("/solutions/sme-and-hyper-growth/") },
      { label: "Corporates and enterprise", href: abs("/solutions/corporates-and-enterprise/") },
      { label: "By approach", href: abs("/solutions/by-approach/") },
    ],
  },
  {
    label: "Frameworks",
    items: [
      { label: "Data Protection", href: abs("/frameworks/data-protection/") },
      { label: "Info Sec SOC2 / ISO27001", href: abs("/frameworks/info-sec-soc2-iso27001/") },
      { label: "AI Act", href: abs("/frameworks/info-sec-soc2-iso27001/#aiact") },
    ],
  },
  { label: "Pricing", href: abs("/pricing/") },
  {
    label: "About Us",
    items: [
      { label: "About us", href: abs("/about-us/") },
      { label: "Contact", href: abs("/contact/") },
    ],
  },
  {
    label: "Resources",
    items: [
      { label: "Blog", href: abs("/blog/") },
      { label: "Data Protection Glossary", href: abs("/data-protection-glossary/") },
      { label: "GDPR Enforcement Tracker", href: abs("/gdpr-enforcement-tracker/") },
      { label: "FAQ", href: abs("/faq/") },
      { label: "Partners", href: abs("/partners/") },
    ],
  },
];

export const FOOTER_COLUMNS = [
  {
    title: "Services",
    links: NAV[0].items,
  },
  {
    title: "Solutions",
    links: [
      { label: "Start up and Fast Movers", href: abs("/solutions/start-ups-and-fast-movers/") },
      { label: "SME and Hyper Growth", href: abs("/solutions/sme-and-hyper-growth/") },
      { label: "Corporates and Enterprise", href: abs("/solutions/corporates-and-enterprise/") },
      { label: "By approach", href: abs("/solutions/by-approach/") },
    ],
  },
  {
    title: "Frameworks",
    links: [
      { label: "Data Protection", href: abs("/frameworks/data-protection/") },
      { label: "Info Sec SOC2 / ISO27001", href: abs("/frameworks/info-sec-soc2-iso27001/") },
      { label: "AI Act", href: abs("/frameworks/info-sec-soc2-iso27001/#aiact") },
    ],
  },
  {
    title: "About us",
    links: [
      { label: "About us", href: abs("/about-us/") },
      { label: "Contact", href: abs("/contact/") },
      { label: "Partners", href: abs("/partners/") },
      { label: "Affiliate", href: abs("/affiliate/") },
    ],
  },
];

export const LEGAL_LINKS = [
  { label: "Cookie Policy", href: abs("/cookie-policy/") },
  { label: "Privacy Policy", href: abs("/privacy-statement/") },
  { label: "DPA/SCC/ADDENDUM", href: abs("/dpa-scc-addendum/") },
  { label: "NDA", href: abs("/nda/") },
  { label: "Terms and Conditions", href: abs("/terms-of-use/") },
];
